function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Icon_Search"
}, React.createElement("path", {
  id: "search",
  d: "M19.3256 20.7122L13.5174 14.9041C13.0116 15.3227 12.4231 15.6495 11.752 15.8847C11.0801 16.1205 10.3692 16.2384 9.61919 16.2384C7.77035 16.2384 6.20477 15.5972 4.92244 14.3149C3.64081 13.0333 3 11.468 3 9.61919C3 7.77035 3.63663 6.20477 4.90988 4.92244C6.18314 3.64081 7.74419 3 9.59302 3C11.4593 3 13.0336 3.64081 14.3159 4.92244C15.5976 6.20477 16.2384 7.77035 16.2384 9.61919C16.2384 10.3692 16.1208 11.0798 15.8857 11.7509C15.6499 12.4228 15.3227 13.0203 14.9041 13.5436L20.7384 19.3517C20.9128 19.5262 21 19.7442 21 20.0058C21 20.2674 20.9041 20.5029 20.7122 20.7122C20.5203 20.9041 20.2894 21 20.0194 21C19.7487 21 19.5174 20.9041 19.3256 20.7122ZM9.61919 14.2762C10.9099 14.2762 12.0087 13.8227 12.9157 12.9157C13.8227 12.0087 14.2762 10.9099 14.2762 9.61919C14.2762 8.31105 13.8227 7.20767 12.9157 6.30907C12.0087 5.41116 10.9099 4.96221 9.61919 4.96221C8.31105 4.96221 7.20802 5.41116 6.31012 6.30907C5.41151 7.20767 4.96221 8.31105 4.96221 9.61919C4.96221 10.9099 5.41151 12.0087 6.31012 12.9157C7.20802 13.8227 8.31105 14.2762 9.61919 14.2762Z",
  fill: "currentColor"
}));

var SvgIconSearch3 = function SvgIconSearch3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconSearch3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-search-3.e960a702.svg";
export { ForwardRef as ReactComponent };